import { SimpleGrid, Image, Flex, Text, Box } from "@chakra-ui/react";
import { useNavigate, Link } from "react-router-dom";

import { Button } from "./ui/button";

import Logo from "../assets/images/logo.png";

export const Header = ({ dark = true }) => {
  const navigate = useNavigate();

  const navOptionsStyle = {
    fontSize: "13px",
    fontWeight: 500,
    color: dark ? "#F8F9FA" : "#101720",
    whiteSpace: "nowrap",
  };

  return (
    <Box bg={dark ? "#0D1E21" : "white"}>
      <SimpleGrid
        h="70px"
        px={{ base: "16px", md: "70px", "2xl": 0 }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
        alignItems={"center"}
        columns={3}
      >
        <Image
          src={Logo}
          h={{ base: "30px", md: "30px" }}
          objectFit={"contain"}
          cursor={"pointer"}
          onClick={() => navigate("/")}
        />

        <Flex
          gap={"74px"}
          align={"center"}
          justifyContent="center"
          width="100%"
          display={{ base: "none", md: "flex" }}
          fontFamily={"Sora-Regular"}
        >
          <Link to="/story">
            <Text style={navOptionsStyle}>Our Story</Text>
          </Link>

          <Link to="/approach">
            <Text style={navOptionsStyle}>Our Approach</Text>
          </Link>

          <Link to="/faq">
            <Text style={navOptionsStyle}>FAQs</Text>
          </Link>

          <Link to="/contact">
            <Text style={navOptionsStyle}>Get Involved</Text>
          </Link>
        </Flex>

        <Flex justifyContent="flex-end" display={{ base: "none", md: "flex" }}>
          <Button onClick={() => navigate("/contact")}>Get Started</Button>
        </Flex>
      </SimpleGrid>
    </Box>
  );
};
